﻿/**
* DevExpress Dashboard (_gauge-element-properties-composer.js)
* Version:  20.1.8
* Build date: Oct 12, 2020
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var gauge_1 = require("../../../model/items/gauge/gauge");
var _gauge_1 = require("../../../model/items/gauge/metadata/_gauge");
var _base_metadata_1 = require("../../../model/metadata/_base-metadata");
var _form_adapter_editors_1 = require("../../form-adapter/_form-adapter-editors");
var _object_properties_wrapper_1 = require("../../form-adapter/_object-properties-wrapper");
var _accordion_tab_1 = require("../../properties-controller/_accordion-tab");
var _display_name_provider_1 = require("../../_display-name-provider");
var _base_properties_composer_1 = require("./_base-properties-composer");
var _shared_composers_1 = require("./_shared-composers");
var GaugeElementPropertiesComposer = (function (_super) {
    __extends(GaugeElementPropertiesComposer, _super);
    function GaugeElementPropertiesComposer(customizeHandler, editFormatHandler) {
        if (editFormatHandler === void 0) { editFormatHandler = function (model) { }; }
        var _this = _super.call(this, customizeHandler) || this;
        _this.editFormatHandler = editFormatHandler;
        return _this;
    }
    GaugeElementPropertiesComposer.prototype._composeTabsCore = function (model, args) {
        var result = [
            new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.Common, 'DashboardWebStringId.Options', this.getCommonWrapper(model, args.dashboardItem, args.dataSourceBrowser)),
            new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.ScaleOptions, 'DashboardWebStringId.Gauge.ScaleOptions', this.getScaleWrapper(model))
        ];
        if (model instanceof gauge_1.Gauge) {
            result.push(new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.DeltaOptions, 'DashboardWebStringId.Grid.DeltaOptions', _shared_composers_1.SharedComposers.getDeltaOptionsWrapper(model.deltaOptions)));
            var wrapper = _shared_composers_1.SharedComposers.getDeltaFormatsOptionsWrapper(model, this.editFormatHandler, { title: 'Gauge Scale', numericFormat: model.scaleLabelNumericFormat });
            var formatsTab = new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.NumericFormat, 'DashboardWebStringId.CardLayout.Editor.FormatOptions', wrapper);
            result.push(formatsTab);
        }
        return result;
    };
    GaugeElementPropertiesComposer.prototype.getCommonWrapper = function (model, dashboardItem, dataSourceBrowser) {
        var properties = [
            __assign({ editorOptions: { placeholder: _display_name_provider_1.getDataItemContainerDisplayName(dataSourceBrowser, dashboardItem, model) } }, _base_metadata_1.name),
        ];
        return new _object_properties_wrapper_1.ObjectPropertiesWrapper({
            model: model,
            properties: properties,
            disabledFilterRules: null
        });
    };
    GaugeElementPropertiesComposer.prototype.getScaleWrapper = function (model) {
        var disabledRules = {};
        return new _object_properties_wrapper_1.ObjectPropertiesWrapper({
            model: model,
            properties: [
                __assign({}, _gauge_1.minimum, { formAdapterItem: _form_adapter_editors_1.nullableNumberBoxEditor({}) }),
                __assign({}, _gauge_1.maximum, { formAdapterItem: _form_adapter_editors_1.nullableNumberBoxEditor({}) })
            ],
            disabledFilterRules: disabledRules
        });
    };
    return GaugeElementPropertiesComposer;
}(_base_properties_composer_1.DataItemContainerPropertiesComposer));
exports.GaugeElementPropertiesComposer = GaugeElementPropertiesComposer;
